export default __webpack_public_path__ + "static/productivity_app_cover-739bf3876c539aea5b38f1438c0d705c.png";